import React, { useState } from 'react';
import { Tooltip, useTheme } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { StyledMapButton, iconStyle } from './materialTheme/StyledMapComponents';
import '../../../static/styles/mapComponents.css';

const FullScreenButton = () => {
  const [isActive, setIsActive] = useState(false);
  const theme = useTheme();

  const toggleFullScreen = () => {
    const mapContainer = document.querySelector('.leaflet-container');
    if (mapContainer) {
      if (!document.fullscreenElement) {
        mapContainer.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    }
    setIsActive(!isActive);
  };

  return (
    <Tooltip title="Toggle Full Screen Mode">
      <StyledMapButton
        variant="contained"
        color="primary"
        onClick={toggleFullScreen}
        startIcon={
          <FullscreenIcon sx={iconStyle({ theme, isActive })} />
        }
        className='full-screen-button'
      />
    </Tooltip>
  );
};

export default FullScreenButton;